import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from "@mui/material";
import confirmationDialogStyles from "./ConfirmationDialog.styles";

function ConfirmationDialog({ open, onClose, onConfirm }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={confirmationDialogStyles.dialogTitle}>Подтверждение</DialogTitle>
      <DialogContent sx={confirmationDialogStyles.dialogContent}>
        <Typography variant="body1">
          Нажимая кнопку "Создать заявку", вы подтверждаете, что ознакомлены с условиями сервиса и соглашаетесь с ними.
        </Typography>
      </DialogContent>
      <DialogActions sx={confirmationDialogStyles.dialogActions}>
        <Button onClick={onClose} color="secondary">Отмена</Button>
        <Button onClick={onConfirm} variant="contained" color="primary">Подтвердить</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationDialog;
